import {gql} from '@apollo/client';

export const CREATE_QUIZ_MUTATION = gql`
    mutation createQuiz ($data: QuizInput!) {
        createQuiz(data: $data) {
            data {
                id
                attributes {
                    createdAt
                    email
                    try
                }
            }
        }
    }
`